// extracted by mini-css-extract-plugin
module.exports = {"container":"_19Xt5mFe0uY93eF1EbBXC2"};